import React from "react";
import {Box, Stack, Typography, useTheme} from "@mui/material";
import {spendColor} from "~/prototypes/pages/taxonomy-canvas/spendColor.ts";

export const SpendLegend: React.FC = () => {
    const theme = useTheme();
    return <Stack sx={{p: 1.5, bgcolor: 'background.paper', border: 1, borderColor: 'divider', borderRadius: 2, boxShadow: 1}}>
        <Typography variant="caption" fontWeight={600}>Spend (mock) vs. same level</Typography>
        <Box sx={{
            mt: 0.5,
            width: 180,
            height: 10,
            borderRadius: 1,
            border: 1,
            borderColor: 'mithraBlue.300',
            background: `linear-gradient(to right, ${spendColor(theme, 0)}, ${spendColor(theme, 0.5)}, ${spendColor(theme, 1)})`,
        }}/>
        <Stack direction="row" justifyContent="space-between">
            <Typography variant="caption" color="mithraBlue.800">Less</Typography>
            <Typography variant="caption" color="mithraBlue.800">More</Typography>
        </Stack>
    </Stack>
}
